/**
 * @fileoverview POST handler for the "/support/cases/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { createMutationFetcherFunctionWithShadowError } from "../reactQueryFetcherAdapters/createMutationFetcherFunctionWithShadowError";
import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { supportCasesAppGroupIdCacheKeys } from "./constants";
import type {
  PostSupportCasesAppGroupIdProps,
  SupportCasesAppGroupIdResult,
  SupportCasesAppGroupIdResultErrors,
} from "./types";

export const postSupportCasesAppGroupId = reactQueryMutationAdapter(
  supportCasesAppGroupIdCacheKeys,
  createMutationFetcherFunctionWithShadowError<SupportCasesAppGroupIdResultErrors>()(
    ({
      appGroupId,
      title,
      description,
      comment,
      emailCc,
      fullStoryUrl,
    }: PostSupportCasesAppGroupIdProps): Promise<SupportCasesAppGroupIdResult> => {
      return fetch(
        `/support/cases/${appGroupId}`,
        "POST",
        {
          title,
          description,
          ...(comment && { comment }),
          email_cc: emailCc,
          ...(fullStoryUrl && { fullstory_url: fullStoryUrl }),
        },
        undefined,
        {
          // don't display a modal on fetch errors
          propagateFetchRequestError: false,
        }
      );
    }
  )
);
